import { type ValidatorFn, Validators } from '@angular/forms';

import { type TableColumnFormat } from '@blaze-shared/elements-domain';
import { BlazeFormValidators } from '@blaze-shared/shared-ui';

export type InputConfigType = 'email' | 'number' | 'text' | 'phoneNumber' | 'url' | 'zipcode';

export interface InputConfig {
  type: InputConfigType;
  validators?: ValidatorFn | ValidatorFn[] | null;
  invalidMsg?: string;
}

const inputValidationConfigMap: Record<string, InputConfig> = {
  text: { type: 'text' },
  paragraph: { type: 'text' },
  number: { type: 'number' },
  percentage: { type: 'number' },
  currency: { type: 'number' },
  email: {
    type: 'email',
    validators: Validators.email,
    invalidMsg: 'Please enter valid email',
  },
  phoneNumber: {
    type: 'phoneNumber',
    validators: BlazeFormValidators.phoneNumber,
    invalidMsg: 'Please enter a valid phone number',
  },
  url: {
    type: 'url',
    validators: BlazeFormValidators.url,
    invalidMsg: 'Please enter a valid URL',
  },
  zipcode: {
    type: 'zipcode',
    validators: BlazeFormValidators.zipCode,
    invalidMsg: 'Please enter a valid zip code',
  },
};

export function getInputValidationConfig(format: TableColumnFormat): InputConfig {
  return inputValidationConfigMap[format] || inputValidationConfigMap.text;
}
